<template>
	<div>
        <div class="row" v-if="!(ready || urlHasToken )">
            <div class="col-12 mb-4">
                <div class="float-right text-right form-inline">
                    <button v-if="$UserSession.hasPriv.call(this, 'ATTENDANCE_OWN_REPORT_VIEW')" 
                        class="btn btn-primary ml-2" 
                        @click="$router.push(`/attendance/studentreport/${$UserSession.getValue('id')}`)"
                    >
                        {{ $t("student-attendance-report") }}
                    </button>
                </div>
                <div
                    class="card"
                    style="width: 18rem; margin: 40px auto 0"
                >
                    <div class="card-body text-center">
                        <!--b-icon
                            icon="check-circle-fill"
                            class="text-success mb-2"
                            style="font-size: 1.5rem"
                        /-->
                        <h5 class="card-title">{{ $t("enter-check-in-code") }}</h5>
                        <p class="card-text">
                            <TextInput v-model="token" :label="$t('code')" :placeholder="$t('eg-code')" class="font-bold"></TextInput>
                        </p>
                            <button class="btn btn-primary" @click="tryCheckin()">{{ $t("done") }}</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="ready" class="row">
            <ActionModal
                :title="
                    loading ? $t('loading') : (error?.error ? $t('error') : $t('checked-in'))
                "
                :text="
                    loading ? $t('loading') : (error?.error ? $t(error.errorMessage) : $t('you-have-successfully-checked-in'))
                "
                :iconType="
                    loading ? '' : (error?.error ? 'exclamation-triangle-fill' : 'check-circle-fill')
                "
                :iconVariant="error?.error ? 'danger' : 'success'"
                iconSize="7.5"
                :modalStyle="{ width: '18rem', margin: '40px auto 0' }"
            >
                <template v-if="!loading" v-slot:content>
                    <Avatar :userId="student?.id" class="avatar avatar--large mb-2 mx-auto"/>
                    <div 
                        class="col-12 text-left">
                        <p v-if="student">
                            {{ $t("name") }}:    <strong>{{ student.displayName }}</strong>
                        </p>
                        <p v-if="checkindatetime">
                            {{ $t("check-in-datetime") }}: <strong>{{ checkindatetime }}</strong>
                        </p> 
                        <p v-if="token">{{ $t('code') }}: <strong>{{ token }}</strong></p>
                        <template v-if="event">
                            <p>{{ $t("event") }}: <strong>{{ event.title }}</strong></p>
                            {{ $t("start") }}: <strong>{{ formatDate(event.ttevent_datetimefrom) }}</strong><br/>
                            {{ $t("end") }}: <strong>{{ formatDate(event.ttevent_datetimeto) }}</strong><br/>
                        </template>
                    </div>
                    <router-link to="/">
                        <button class="btn btn-primary mt-2">{{ $t("done") }}</button>
                    </router-link>
                </template>
            </ActionModal>
        </div>
	</div>
</template>

<script>
import ActionModal from '@/components/ActionModal.vue';
import Avatar from '../../components/Avatar.vue';
export default {
	data() {
		return {
			ready: false,
			checkedin: false,
            token:null,
            urlHasToken: false,
            error: null,
            event: null,
            student: null,
            checkindatetime: null,
            loading: true
		};
	},
    components: {
        ActionModal,
        Avatar
    },
	mounted() {
        if(this.$route.params["token"]){
            this.urlHasToken = true;
            this.token = this.$route.params["token"];
            this.tryCheckin();
        }

	},
	methods: {
		tryCheckin() {
			//this.$store.commit("showBlockingSpinner");
            this.loading = true;
			this.$cfetch(`${this.$settings.APIBaseURL}/attendance/register/checkin`, {
				data: {
					'token': this.token,
				},
			}).then((res) => {
                this.$users.getUserById.call(this, res.student_id).then(user => {
                    this.student = user
                }).catch((err) => {
                    this.$log.error.call(this, err)
                    console.error(err); 
                });

                this.checkindatetime = new Date().toLocaleString();

                if (res.status !== "SUCCESS") {
                    this.error = res;
                    throw new Error(res);
				}

                this.event = res.ttevent;
                
			}).catch((err) => {
                this.$log.error.call(this, err)
                console.error(err); 
            }).finally(() => {
				this.ready = true;
                this.loading = false;
				this.$store.commit("hideBlockingSpinner");
			});
		},
        formatDate(dateString) {
            const date = new Date(dateString);
            
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            
            return `${year}/${month}/${day}, ${hours}:${minutes}`;
        }

    }
};
</script>
